export default {
  reports: {
    gen: "Geslacht",
    total: "Totaal",
    gender: "Geslachtstabel",
    male: "Mannelijk",
    female: "Vrouwelijk",
    other: "Anders",
    byCountry: "Per land",
    avgPriceFarmer: "Gemiddelde prijs betaald aan boer (Cacao)",
    avgPrice: "Gemiddelde prijs",
    selectYear: "Selecteer jaar",
    farmerName: "Naam van de boer",
    farmerProdChart: "Grafiek van boerenproductie",
    production: "Productie",
    byProduction: "Per productie",
    byName: "Per naam",
    descending: "Aflopend",
    ascending: "Oplopend",
    buyingStationProdChart: "Grafiek van productie van inkoopstation",
    buyingStation: "Inkoopstation",
    buyingStationName: "Naam van inkoopstation",
    dryMilling: "Droge maling",
    dryMillingName: "Naam van droge maling",
    dryMillingProdChart: "Grafiek van productie van droge maling",
    view: "Weergave",
    date: "Datum",
    reports: "Rapporten",
    today: "Vandaag",
    week: "Week",
    month: "Maand",
    year: "Jaar",
    all: "Alles",
    selectCrop: "Selecteer Gewas",
    selectRegion: "Selecteer Regio",
    selectProvinceState: "Selecteer Provincie/Status",
    downloadPdfReport: "Downloaden PDF-rapport",
    export: "Exporteer",
    search: "Zoeken",
    yield: "Opbrengst",
    averageSellingPriceByAllFarmers: "Gemiddelde verkoopprijs door alle boeren",
    averageSellingPricePerFarmer: "Gemiddelde verkoopprijs per boer",
    pricePaid: "Betaalde prijs",
    pests: {
      pestReport: "Plaagrapport",
      filterByCrops: "Filteren op gewassen",
      pestStatistics: "Plaagstatistieken",
      regions: "Regio's",
      occurrences: "Voorvallen",
      pestChart: "Plaaggrafiek",
      totalArea: "Totale oppervlakte",
      pestName: "Naam van de plaag",
      region: "Regio",
      crop: "Gewassen",
      listByLand: "Lijst per land",
    },
    regions: {
      regionalReport: "Regionaal rapport",
      listByFarm: "Lijst per boerderij",
      listByFarmers: "Lijst per boeren",
      listByYield: "Lijst per opbrengst",
      regionalStatistics: "Regionale statistieken",
      countries: "Landen",
      states: "Staten/Provincies",
      city: "Stad/Dorp",
      farmsIn: "Boerderijen in",
      regionalChart: "Regionale grafiek",
      farms: "Boerderijen",
      regionName: "Naam van de regio",
      farmers: "Boeren",
      yield: "Opbrengst/Acre",
    },
    dashboard: {
      topCharts: "Topgrafieken",
      regions: "Regio's",
      noOfFarms: "Aantal Boerderijen/Gebieden",
      provinces: "Provincies",
      landArea: "Landoppervlakte",
      avgFarmerLand: "Gemiddeld Boerenland",
      viewAll: "Bekijk Alles",
      crops: "Gewassen",
      plantedAreaCrop: "Gepland Gebied/Gewas",
      plantedArea: "Gepland Gebied",
      avgYieldCrop: "Gemiddelde Opbrengst/Gewas",
      averageYield: "Gemiddelde Opbrengst",
      yieldChart: "Opbrengstgrafiek",
      selectFarm: "Selecteer Boerderij",
      soilQuality: "Grondkwaliteit",
      pests: "Ongedierte",
      occurrences: "Voorvallen",
      equipments: "Apparatuur",
      goalAchievedChart: "Grafiek van Bereikte Doelen",
      soilValues: "Grondwaarden",
      soil: "Grond",
      showReport: "Toon Rapport op Dashboard",
      selectAll: "Selecteer Alles",
    },
  },
};
